import { CssBaseline } from '@mui/material'
import PropTypes from 'prop-types'

export const AdasCssBaseline = ({ children, ...props }) => <CssBaseline {...props}>{children}</CssBaseline>

AdasCssBaseline.propTypes = {
  children: PropTypes.node
}
